import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useQueryParams } from "../../../../../../hooks/useQueryParams";
import useRevalidateParent from "../../../../../../hooks/useRevalidateParent";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import DrawerFilters, { DrawerFiltersList, useDrawerFilters } from "../../../../drawer-filters";
import AddActionItemModal from "../../../../FollowUps/ActionableItems/AddActionItemModal";
import StatusSelect from "../../components/StatusSelect";
import { SwimLaneFilters } from "../../helpers/swimlane-filters";

import ButttonLink from "./components/ButtonLink";
import Columns from "./components/Columns";
import ColumnsHeader from "./components/ColumnsHeader";
import NoData from "./components/NoData";
import Title from "./components/Title";
import ViewCompletedActionItem from "./components/ViewCompletedItem";
import SwimLanesLayout from "./SwimLanesLayout";

export default function SwimLanes({
  title,
  statusFilterOptionsList,
  actionItems,
  actionItemsCounts,
  lanes,
  isLoadingLanes,
  isLoadingActionItems,
}) {
  const { filters } = useQueryParams();
  const revalidateParent = useRevalidateParent("rvDashboardId");
  const statusFilterDefault = filters.get("status") ?? "pending";
  const { filterState } = useDrawerFilters(SwimLaneFilters, {
    replaceNavigation: true,
  });

  const [filteredActionItems, setFilteredActionItems] = useState(actionItems);
  const [sortedLanes, setSortedLanes] = useState(lanes);
  const [toggleAddActionItems, setToggleAddActionItems] = useState(false);
  const [activeActionItem, setActiveActionItem] = useState(null);
  const [subtitle, setSubtitle] = useState(
    statusFilterOptionsList.find((g) => g.value === statusFilterDefault).label
  );
  const [openCompleteModal, setOpenCompleteModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSortedLanes(lanes);
    setFilteredActionItems(actionItems);
    const filterParam = location.search;
    const params = Object.fromEntries(new URLSearchParams(filterParam));
    if (params?.status) {
      const updatedStatus = statusFilterOptionsList.find((g) => g.value === params?.status).label;
      setSubtitle(updatedStatus);
    }
  }, [actionItems, lanes, location.search]);

  const openAddActionItemModal = () => {
    setActiveActionItem(null);
    setToggleAddActionItems(true);
  };
  const handleCompletedModal = (value) => {
    if (!value) {
      setActiveActionItem(null);
    }
    setOpenCompleteModal(value);
  };

  return (
    <div>
      <SwimLanesLayout>
        <SwimLanesLayout.Header>
          <Title title={title} subtitle={subtitle} />
          <div className="flex items-center gap-4 py-4 mt-6">
            <StatusSelect
              defaultSelection={subtitle}
              optionsList={statusFilterOptionsList}
              setSelectionInParent={setSubtitle}
            />
            <DrawerFilters
              title="Filters"
              triggerId="swimlanes-filters-button"
              closeButtonId="swimlanes-filters-close-button"
              icon={<Svg name={SvgEnum.HisFilters} color={HNSColors.secondary[400]} />}
              buttonSx={{
                padding: "5px 20px 5px 20px",
                minWidth: "150px",
              }}
            >
              <DrawerFiltersList filterState={filterState} />
            </DrawerFilters>
            <ButttonLink label={"+ Add Action Item"} onClickHandler={openAddActionItemModal} />
          </div>
        </SwimLanesLayout.Header>
        <SwimLanesLayout.Main>
          {sortedLanes && sortedLanes.length > 0 ? (
            <>
              <ColumnsHeader columnList={sortedLanes} actionItemsCounts={actionItemsCounts} />
              <Columns
                columns={sortedLanes}
                items={filteredActionItems}
                setOpenAddActionItemModal={setToggleAddActionItems}
                setActiveActionItem={setActiveActionItem}
                setOpenCompleteModal={handleCompletedModal}
                isLoading={isLoadingActionItems}
              />
            </>
          ) : (
            <NoData isLoading={isLoadingLanes} />
          )}
        </SwimLanesLayout.Main>
      </SwimLanesLayout>
      <AddActionItemModal
        addOpen={toggleAddActionItems}
        setAddOpen={setToggleAddActionItems}
        activeActionItem={activeActionItem}
        setActiveActionItem={setActiveActionItem}
        externalRevalidate={revalidateParent}
      />
      {openCompleteModal && (
        <ViewCompletedActionItem
          title={"Completed Action Item"}
          selectedActionItem={activeActionItem}
          openCompleteModal={openCompleteModal}
          handleClose={handleCompletedModal}
        />
      )}
    </div>
  );
}
